import type { ProjectView } from '@/types/current-project';

export function receivedEvaluations(project: ProjectView, account: string) {
  return project.evaluations.flatMap((evaluation) =>
    evaluation.ratings
      .filter((vote) => vote.account === account)
      .map((vote) => ({ author: evaluation.author, score: vote.score }))
  );
}

export function reputationStars(score?: {
  weightedScoreSum: string;
  ratedMinutes: number;
}) {
  if (!score) return null;
  if (
    !Number.isSafeInteger(score.ratedMinutes) ||
    score.ratedMinutes < 0 ||
    !/^[0-9]+$/.test(score.weightedScoreSum)
  )
    return null;
  const sum = BigInt(score.weightedScoreSum);
  if (sum > BigInt(score.ratedMinutes) * 500n) return null;
  if (score.ratedMinutes === 0) return 0;
  // The provider records hundredths of a star weighted by the rated minutes.
  return (
    Number(BigInt(score.weightedScoreSum) / BigInt(score.ratedMinutes)) / 100
  );
}
